import { createFeature, createReducer, on } from '@ngrx/store';
import * as SkuSearchActions from './sku-search.actions';
import { SearchOption, Sku } from '@emi/shared/models';
export interface SkuSearchState {
    isLoading: boolean;
    searchTerm: string;
    searchOption: SearchOption;
    skuResults: Sku[];
    pageIds: string[];
    currency: string;
    skuCount: number;
    error: string;
    isSkuSuggestion: boolean;
    sortBy: string | undefined;
    orderBy: string | undefined;
    includeSearchPhrase: boolean | undefined;
}

export const skuSearchFeatureKey = 'skuSearch';

export const initialState: SkuSearchState = {
    isLoading: false,
    searchTerm: '',
    searchOption: new SearchOption(0, ''),
    skuResults: [],
    pageIds: [],
    currency: 'USD',
    skuCount: 0,
    error: '',
    isSkuSuggestion: false,
    sortBy: undefined,
    orderBy: undefined,
    includeSearchPhrase: true
};

export const skuSearchFeature = createFeature({
    name: skuSearchFeatureKey,
    reducer: createReducer(
        initialState,
        on(SkuSearchActions.getSkuSearchResults, (state, { searchTerm, searchOption, sortBy, orderBy, includeSearchPhrase }) => {
            return {
                ...state,
                searchTerm,
                searchOption,
                pageIds: [],
                skuResults: [],
                skuCount: 0,
                isLoading: true,
                sortBy: sortBy,
                orderBy: orderBy,
                includeSearchPhrase: includeSearchPhrase,
            };
        }),
        on(SkuSearchActions.getSkuSearchResultsSuccess, (state, { results, skuCount, nextPageId }) => {
            return {
                ...state,
                skuResults: results,
                pageIds: [nextPageId],
                skuCount: skuCount,
                isLoading: false,
            };
        }),
        on(SkuSearchActions.getSkuSearchResultsFailure, (state, { error }) => {
            return {
                ...state,
                isLoading: false,
                error: error.message,
            };
        }),
        on(SkuSearchActions.getNextPageSkuSearchResults, (state) => {
            return {
                ...state,
                isLoading: true,
            };
        }),
        on(SkuSearchActions.updateSkuSearchResultsSuccess, (state, { results, nextPageId }) => {
            return {
                ...state,
                skuResults: [...state.skuResults, ...results],
                pageIds: [...state.pageIds, nextPageId],
                isLoading: false,
                error: '',
            };
        }),
        on(SkuSearchActions.getSkuCountSuccess, (state, { skuCount }) => {
            return {
                ...state,
                skuCount: skuCount,
                isLoading: false,
            };
        }),
        on(SkuSearchActions.getSkuCountFailure, (state, { error }) => {
            return {
                ...state,
                isLoading: false,
                error: error.message,
            };
        }),
        on(SkuSearchActions.setCurrency, (state, { currency }) => {
            return {
                ...state,
                currency: currency,
            };
        }),        
        on(SkuSearchActions.setSortBy, (state, { sortBy }) => {
            return {
                ...state,
                sortBy: sortBy,
            };
        }),
        on(SkuSearchActions.setOrderBy, (state, { orderBy }) => {
            return {
                ...state,
                orderBy: orderBy,
            };
        }),
        on(SkuSearchActions.clearSearchResults, () => {
            return initialState;
        })
    ),
});
